(ns common.schema.entities.lp-portal.lp-news-item
  (:require
   [common.schema.schema-utils :as su]
   [common.country :as country]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (concat (su/text-simple-field :lp-news-item/title
                                "Title"
                                (system-controlled {:authorization su/access-system-lpg}))
          (su/single-ref-field :lp-news-item/type-id
                               "Type"
                               [:entity.type/lp-news-type]
                               {:authorization su/access-zadmin-lpg})
          (su/multi-ref-field :lp-news-item/categories
                              "Category"
                              [:entity.type/lp-news-category]
                              {:authorization             su/access-zadmin-lpg
                               :default-field-visibility :in-use})
          (su/date-field :lp-news-item/publication-date
                         "Publication date"
                         (system-controlled {:authorization su/access-system-lpg}))
          (su/url-field :lp-news-item/cover-image-url
                        "Cover image URL"
                        (system-controlled {:authorization su/access-system-lpg}))
          (su/url-field :lp-news-item/content-url
                        "Content URL"
                        (system-controlled {:authorization su/access-system-lpg}))
          (su/keyword-field :lp-news-item/source
                            "Scraping source"
                            nil
                            (system-controlled {:authorization su/access-system-lpg}))
          (su/keyword-multi-field :lp-news-item/target-countries
                                  "Target countries"
                                  country/options
                                  (system-controlled {:authorization su/access-system-lpg}))
          (su/multi-ref-field :lp-news-item/target-funds
                              "Target funds"
                              nil
                              (system-controlled {:authorization             su/access-system-lpg
                                                  :default-field-visibility :in-use}))))
